export function slash(path) {
    return /^\\\\\?\\/.test(path) ? path : path.replace(/\\/g, "/");
}
